import { Component, ElementRef, inject, signal, ViewChild } from '@angular/core';
import { StationFacade } from '../station.facade';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MatIcon } from "@angular/material/icon";
import { StationLongDto } from '@api/rest';
import { FullRoutingService } from '@app/core/services/full-routing.service';
import { Router } from '@angular/router';
import { AppService } from '@app/core/services/app.service';
import { map, Observable } from 'rxjs';
import { ContentFacade } from '@app/content/content.facade';
import { ContentType } from '@app/shared/enums/content-type.enum.ts';
import { AsyncPipe } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-favorite-list',
  imports: [TranslatePipe, MatIcon, AsyncPipe, MatButton],
  templateUrl: './favorite-list.component.html',
  styleUrl: './favorite-list.component.scss'
})
export class FavoriteListComponent {
  private readonly stationFacade = inject(StationFacade);
  private readonly fullRoutingService = inject(FullRoutingService);
  private readonly router = inject(Router);
  private readonly appService = inject(AppService);
  private readonly contentFacade = inject(ContentFacade);

  protected readonly dynamicContentUrlSignal = this.appService.dynamicContentUrlSignal;
  protected readonly translate = inject(TranslateService);
  protected readonly favoritesStationsSignal = this.stationFacade.favoriteStationsSignal;
  protected readonly currentSelectedFavoriteIdToDelete = signal<string | undefined>(undefined);

  @ViewChild('popoverDeleteFavorite') popoverDeleteFavorite!: ElementRef;

  protected onClickNewSuggestions() {
    this.router.navigate(['/favorite-suggestion']);
  }

  protected onClickDeleteFavorite(event: MouseEvent, favoriteId: string) {
    this.currentSelectedFavoriteIdToDelete.set(favoriteId);
    this.popoverDeleteFavorite?.nativeElement?.showPopover();
    event.stopPropagation();
  }

  protected onClickFavorite(favorite: StationLongDto) {
    this.fullRoutingService.navigateToStationWithExhibtionAndTourSuffix(favorite.parent_ref?.[0], favorite.id);
  }

  protected deleteCurrentSelectedFavorite() {
    const toDelete = this.currentSelectedFavoriteIdToDelete();
    if (toDelete !== undefined) {
      this.stationFacade.removeFavorite(toDelete);
      this.currentSelectedFavoriteIdToDelete.set(undefined);
    }
    this.popoverDeleteFavorite?.nativeElement?.hidePopover();
  }

  protected getIconContent(station: StationLongDto): Observable<string> {
    return this.contentFacade.getContentForStationByType(station, ContentType.Icon)
      .pipe(
        map(iconContent => iconContent?.length > 0
          ? iconContent[0].files?.length > 0 ? iconContent[0].files[0]?.href : undefined : undefined)
      );
  }
}
